import { JSX, SVGProps } from 'react';

export const Star = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg width={22} height={21} viewBox="0 0 22 21" fill="none" {...props}>
    <path
      d="M10.5383 0.710061C10.7091 0.299415 11.2909 0.299416 11.4617 0.710062L14.0568 6.94943C14.1288 7.12254 14.2916 7.24083 14.4785 7.25581L21.2144 7.79583C21.6577 7.83137 21.8375 8.38462 21.4997 8.67396L16.3676 13.0701C16.2252 13.1921 16.1631 13.3835 16.2066 13.5659L17.7745 20.139C17.8777 20.5716 17.4071 20.9135 17.0275 20.6817L11.2606 17.1593C11.1006 17.0616 10.8994 17.0616 10.7394 17.1593L4.97249 20.6817C4.59294 20.9135 4.12231 20.5716 4.22551 20.139L5.79343 13.5659C5.83694 13.3835 5.77475 13.1921 5.63236 13.0701L0.5003 8.67396C0.162531 8.38462 0.342295 7.83137 0.785622 7.79583L7.52154 7.25581C7.70843 7.24083 7.87124 7.12254 7.94324 6.94943L10.5383 0.710061Z"
      fill="#FDB022"
    />
  </svg>
);
